<template>
  <div>
    school_home
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
</style>